<template>
  <div
    class="d-flex-column justify-start align-start work_with_us_spacing why_us_new"
  >
    <div class="d-flex-column justify-start align-start gap-24">
      <label
        class="t-orange font-family-2 caps regular-l"
        style="letter-spacing: 2.24px"
        >{{ $t("common.about") }}</label
      >
      <h1 class="t-white font-family-1 title-h2 f-w-600">
        {{ $t("work_with_us.why_boosting_market") }}
      </h1>
      <p class="t-grey font-family-2 regular-xxl" style="max-width: 90ch">
        {{ $t("work_with_us_2.why_us_description") }}
      </p>
    </div>

    <div class="stats_container">
      <div
        class="d-flex-column justify-start align-start gap-0"
        v-for="stat in stats"
        :key="stat.stat"
      >
        <h2 class="t-orange font-family-1 title-h2">
          {{ stat.stat }}
        </h2>

        <p class="t-grey font-family-2 regular-xl">
          {{ $t(`work_with_us_2.${stat.title}`) }}
        </p>
      </div>
    </div>

    <hr class="horizontal" />

    <div class="why_us_benefit_card_container">
      <BenefitCard
        v-for="(benefit, index) in benefits"
        :key="benefit"
        :title="benefit.title"
        :description="benefit.description"
        :image="benefit.image"
      />
    </div>
  </div>
</template>

<script setup>
import BenefitCard from '../cards/BenefitCard.vue';
const { t } = useI18n();

const stats = ref([
  {
    title: "stats.available_for_service",
    stat: "20+ Games",
  },
  {
    title: "stats.clients_ordered",
    stat: "50,000+",
  },
  {
    title: "stats.booster_in_team",
    stat: "520+",
  },
  {
    title: "stats.years",
    stat: "9 Years",
  },
]);

const benefits = computed(() => {
  return [
    {
      title: t("work_with_us_2.benefit_title_1"),
      description: t("work_with_us_2.benefit_description_1"),
      image: "/images/work-with-us/benefit_1.webp",
    },
    {
      title: t("work_with_us_2.benefit_title_2"),
      description: t("work_with_us_2.benefit_description_2"),
      image: "/images/work-with-us/benefit_2.webp",
    },
    {
      title: t("work_with_us_2.benefit_title_3"),
      description: t("work_with_us_2.benefit_description_3"),
      image: "/images/work-with-us/benefit_3.webp",
    },
    {
      title: t("work_with_us_2.benefit_title_4"),
      description: t("work_with_us_2.benefit_description_4"),
      image: "/images/work-with-us/benefit_4.webp",
    },
    {
      title: t("work_with_us_2.benefit_title_5"),
      description: t("work_with_us_2.benefit_description_5"),
      image: "/images/work-with-us/benefit_5.webp",
    },
    {
      title: t("work_with_us_2.benefit_title_6"),
      description: t("work_with_us_2.benefit_description_6"),
      image: "/images/work-with-us/benefit_6.webp",
    },
  ];
});
</script>

<style lang="scss">
.why_us_new {
  gap: 56px;
  .stats_container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(auto, 1fr);
    grid-column-gap: 56px;
    grid-row-gap: 56px;
  }

  @media screen and (max-width: 900px) {
    gap: 40px;
    .stats_container {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 32px;
      grid-row-gap: 32px;
    }
  }

  @media screen and (max-width: 600px) {
    .stats_container {
      grid-template-columns: repeat(1, 1fr);
      grid-column-gap: 24px;
      grid-row-gap: 24px;
    }
  }
}
</style>
